import React from "react";
import { Link, useLocation } from "react-router-dom";
import Copyright from "./Copyright";

function Footer() {
  return (
    <section className="footer-con position-relative">

      {/* BACKGROUND IMAGE */}
      <figure className="footer-image mb-0">
        <img
          className="img-fluid"
          src="/assets/images/footer-image.png"
          alt="footer"
        />
      </figure>

      <div className="container-header">

        <div className="middle_portion">
          <div className="row">

            {/* LOGO */}
            <div className="col-lg-2 col-md-12 col-sm-6 col-12">
              <a href="/">
                <figure className="footer-logo mb-0">
                  <img
                    className="img-fluid"
                    src="/assets/website-images/logo-white.png"
                    alt="logo"
                  />
                </figure>
              </a>

              <p className="footer-desc">
                Premium handcrafted gelato made with the finest ingredients, bringing joy and freshness in every scoop.
             </p>

            </div>

            {/* NAVIGATION */}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="links">
              <h5 className="heading">Quick Links</h5>

              <div className="footer-links">
              <Link to="/"> Home</Link>
              <Link to="/about">About</Link>
              <Link to="/products">Products</Link>
              <Link to="/contacts">Contact Us</Link>
              <Link to="/locations">Locations</Link>
            </div>

            </div>
          </div>

            {/* ADDRESS + EMAIL */}
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="info">

                <div className="info-item">
                  <i className="fa-solid fa-location-dot"></i>

                  <div className="text">
                    <span>Address</span>
                    <a
                      href="https://www.google.com/maps"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Mohan's Plaza
                      733, Road No. 36, Guttala_Begumpet, CBI Colony, Jubilee Hills, Hyderabad, Telangana 500033
                    </a>
                  </div>
                </div>

                <div className="info-item">
                  <i className="fas fa-envelope-open-text"></i>

                  <div className="text">
                    <span>Email</span>
                    <a href="mailto:hello@festivogelato.com">
                      hello@festivogelato.com
                    </a>
                  </div>
                </div>

              </div>
            </div>

            {/* PHONE + SOCIAL */}
            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
              <div className="icon">

                <div className="phone_wrapper">
                  <i className="fa-solid fa-phone"></i>

                  <div className="text">
                    <a href="tel:+917207684455">
                      +91 72076 84455
                    </a>
                    <span>Got Questions? Call us 24/7</span>
                  </div>
                </div>

                <div className="social-icons d-flex gap-5">
                  <a href="https://youtube.com/@festivogelato?si=2-xo36HSbaOJHg8z" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                  <a href="https://www.instagram.com/festivogelato?igsh=eXE2MXo3YW16em9j" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>

        {/* COPYRIGHT */}
        <Copyright />

      </div>
    </section>
  );
}

export default Footer;
